import React from "react"
import { VictoryAxis, VictoryTheme } from "victory"
import moment from "moment"
import PropTypes from "prop-types"

// Example outputs: "7/1", "10/17 (peak)", "WK of 8/5", "Jun"
const formatXTick = (timeslice, timeslices, maxAssetsUsed, howManyPeaks) => {
  const timesliceIsPeak = timeslice.peakUtilizedCount === maxAssetsUsed
  const timesliceIsAtEnd =
    timeslice === timeslices[0] ||
    timeslice === timeslices[timeslices.length - 1]

  if (!timesliceIsAtEnd && !timesliceIsPeak) {
    return null
  }

  const date = moment.parseZone(timeslice.startsAt)
  switch (timeslice.period) {
    case "day":
      return timesliceIsPeak && howManyPeaks === 1
        ? `${date.format("M/D")} (peak)`
        : date.format("M/D")
    case "week":
      return timesliceIsAtEnd
        ? date.format("M/D")
        : `WK of ${date.format("M/D")}`
    case "month":
      return date.format("MMM")
    /* istanbul ignore next */
    default:
      throw Error(`Invalid period: ${timeslice.period}`)
  }
}

const XAxis = ({
  timeslices,
  notEnoughData,
  maxAssetsUsed,
  howManyPeaks,
  gradientFn,
  bare,
}) => {
  return (
    <VictoryAxis
      key="x-axis"
      theme={VictoryTheme.material}
      className="xAxis"
      tickCount={timeslices.length < 1 ? 1 : timeslices.length}
      tickFormat={x =>
        notEnoughData || !timeslices[x - 1]
          ? null
          : formatXTick(
              timeslices[x - 1],
              timeslices,
              maxAssetsUsed,
              howManyPeaks
            )
      }
      style={{
        tickLabels: { fontSize: 10 },
        grid: {
          stroke: ({ tick }) => {
            if (notEnoughData) {
              return "none"
            }
            const timeslice = timeslices[tick - 1]
            return timeslice && timeslice.peakUtilizedCount === maxAssetsUsed
              ? gradientFn(timeslice.peakUtilizedCount)
              : "none"
          },
        },
      }}
    />
  )
}

XAxis.propTypes = {
  timeslices: PropTypes.arrayOf(
    PropTypes.shape({
      startsAt: PropTypes.string.isRequired,
      period: PropTypes.oneOf(["day", "week", "month"]).isRequired,
      peakUtilizedCount: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  bare: PropTypes.bool,
  notEnoughData: PropTypes.bool,
  maxAssetsUsed: PropTypes.number,
  howManyPeaks: PropTypes.number,
  gradientFn: PropTypes.func,
}

export default XAxis
